<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <v-container>
        <v-row align="center">
          <v-col cols="8">
            <div class="text-h5 font-weight-bold">Datos generales</div>
          </v-col>
          <v-col cols="4" align="right">
            <v-btn rounded color="secondary" @click="triggerUpdatePersonal"
              >Guardar cambios<v-icon small class="ml-4">mdi-pencil</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
              <v-tab class="font-weight-bold">Información <br />principal</v-tab>
              <v-tab class="font-weight-bold">Nacionalidad</v-tab>
              <v-tab class="font-weight-bold">Documentación <br />oficial</v-tab>
              <v-tab class="font-weight-bold">Información <br />personal</v-tab>
              <v-tab class="font-weight-bold">Domicilio</v-tab>
              <v-tab class="font-weight-bold">Estudios</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1" eager>
          <InformacionPrincipalTabContent />
        </v-tab-item>
        <v-tab-item key="2" eager>
          <NacionalidadTabContent />
        </v-tab-item>
        <v-tab-item key="3" eager>
          <DocumentacionOficialTabContent />
        </v-tab-item>
        <v-tab-item key="4" eager>
          <InformacionPersonalTabContent />
        </v-tab-item>
        <v-tab-item key="5" eager>
          <DomicilioTabContent />
        </v-tab-item>
        <v-tab-item key="6" eager>
          <EstudiosTabContent />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InformacionPrincipalTabContent from './datos-generales/tab-content/InformacionPrincipalTabContent.vue'
import NacionalidadTabContent from './datos-generales/tab-content/NacionalidadTabContent.vue'
import DocumentacionOficialTabContent from './datos-generales/tab-content/DocumentacionOficialTabContent.vue'
import InformacionPersonalTabContent from './datos-generales/tab-content/InformacionPersonalTabContent.vue'
import DomicilioTabContent from './datos-generales/tab-content/DomicilioTabContent.vue'
import EstudiosTabContent from './datos-generales/tab-content/EstudiosTabContent.vue'

export default {
  components: {
    InformacionPrincipalTabContent,
    NacionalidadTabContent,
    DocumentacionOficialTabContent,
    InformacionPersonalTabContent,
    DomicilioTabContent,
    EstudiosTabContent,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },
  methods: {
    ...mapActions('personal', ['updatePersonal']),
    async triggerUpdatePersonal() {
      await this.updatePersonal(this.personal)
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para DatosGeneralesComponent */

/* Animación de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Card principal */
.card {
  background: rgba(26, 30, 46, 0.7) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

.card:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4);
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
}

/* Card title */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  padding: 24px !important;
}

/* Card text */
::v-deep .v-card-text {
  color: #e0e0e0 !important;
}

/* Títulos */
.text-h5 {
  color: #ffffff !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Tabs */
::v-deep .v-tabs {
  background: transparent !important;
}

::v-deep .v-tab {
  color: rgba(224, 224, 224, 0.7) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  border-radius: 8px 8px 0 0;
  margin: 0 4px;
}

::v-deep .v-tab:hover {
  color: var(--v-secondary-base) !important;
  background: rgba(var(--v-secondary-base-rgb), 0.08);
}

::v-deep .v-tab--active {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  background: rgba(var(--v-secondary-base-rgb), 0.12);
}

::v-deep .v-tabs-slider {
  background: var(--v-secondary-base) !important;
  height: 3px !important;
  border-radius: 3px 3px 0 0;
  box-shadow: 0 2px 8px rgba(var(--v-secondary-base-rgb), 0.5);
}

/* Tab items */
::v-deep .v-tabs-items {
  background: transparent !important;
}

::v-deep .v-window__container {
  background: transparent !important;
}

/* Botones modernos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn.secondary,
::v-deep .v-btn[color='secondary'] {
  background: var(--v-secondary-base) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
  font-weight: 700 !important;
}

::v-deep .v-btn.secondary:hover:not(:disabled),
::v-deep .v-btn[color='secondary']:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn.secondary:active:not(:disabled),
::v-deep .v-btn[color='secondary']:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.5) !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.15) rotate(5deg);
}

/* Container y Grid */
::v-deep .v-container {
  padding: 16px;
}

/* Responsive */
@media (max-width: 960px) {
  ::v-deep .v-tab {
    font-size: 0.75rem !important;
    padding: 0 8px !important;
  }

  .text-h5 {
    font-size: 1.25rem !important;
  }

  ::v-deep .v-btn {
    font-size: 0.875rem !important;
  }
}

@media (max-width: 600px) {
  ::v-deep .v-card-title {
    padding: 16px !important;
  }

  ::v-deep .v-tab {
    font-size: 0.625rem !important;
    min-width: 60px !important;
    padding: 0 4px !important;
  }

  .text-h5 {
    font-size: 1rem !important;
  }
}
</style>
